var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRate2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 25,
    viewBox: "0 0 140 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.825 22.5L7.45 15.475L2 10.75L9.2 10.125L12 3.5L14.8 10.125L22 10.75L16.55 15.475L18.175 22.5L12 18.775L5.825 22.5Z",
    fill: "#02980E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.825 22.5L36.45 15.475L31 10.75L38.2 10.125L41 3.5L43.8 10.125L51 10.75L45.55 15.475L47.175 22.5L41 18.775L34.825 22.5Z",
    fill: "#02980E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63.825 22.5L65.45 15.475L60 10.75L67.2 10.125L70 3.5L72.8 10.125L80 10.75L74.55 15.475L76.175 22.5L70 18.775L63.825 22.5Z",
    fill: "#02980E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M92.825 22.5L94.45 15.475L89 10.75L96.2 10.125L99 3.5L101.8 10.125L109 10.75L103.55 15.475L105.175 22.5L99 18.775L92.825 22.5Z",
    fill: "#02980E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M121.825 22.5L123.45 15.475L118 10.75L125.2 10.125L128 3.5L130.8 10.125L138 10.75L132.55 15.475L134.175 22.5L128 18.775L121.825 22.5Z",
    fill: "#919891"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRate2);
export default __webpack_public_path__ + "static/media/rate2.a4277d6f5a1d8e1d1fdae8277acb64a8.svg";
export { ForwardRef as ReactComponent };